/** @jsxImportSource @emotion/react */
import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useMatch } from 'react-router-dom';
import type { DivProps } from 'typings';
import UDColorableIcon from 'ud-ui/components/icon/colorable-icon';
import UDNavLink from 'ud-ui/components/link/nav-link';
import * as S from './styles';

interface ITournamentHeaderProps extends DivProps {
  isOpen?: boolean;
  showRecentlyAdded?: boolean;
  hasRecentlyAdded?: boolean;
}

function TournamentHeader(props: ITournamentHeaderProps) {
  const { isOpen, showRecentlyAdded, hasRecentlyAdded, ...rest } = props;
  const isOnChampionship = useMatch(Pages.CHAMPIONSHIPS.INDEX + '/*');

  if (!hasRecentlyAdded) {
    return (
      <UDNavLink
        to={Pages.CHAMPIONSHIPS.INDEX}
        checkPath={Pages.CHAMPIONSHIPS.INDEX + '/*'}
        variant="secondary"
        className={'nav-item subhead flex items-center px-10'}
      >
        <UDColorableIcon name="cup" size={16} componentProps={{ className: 'mr-2' }} />
        <Trans>Турниры</Trans>
      </UDNavLink>
    );
  }

  return (
    <S.MainBlock
      {...rest}
      className={classNames('nav-item text subhead flex items-center px-10', {
        active: isOnChampionship,
      })}
    >
      <UDColorableIcon name="cup" size={16} componentProps={{ className: 'mr-2' }} />
      <Trans>Турниры</Trans>
      <div style={{ position: 'absolute', right: 40 }}>
        <ChevronDown
          size={16}
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        />
      </div>
    </S.MainBlock>
  );
}

export default TournamentHeader;
